export default "__VITE_ASSET__8N$E8CBK__"